import Vue from 'vue';
import Vuex from 'vuex';
import VueSession from 'vue-session';

Vue.use(Vuex);
Vue.use(VueSession);
export default new Vuex.Store({
    state: {
        boardId: '',
        page: 1,
        flag: '',
        // token: '',
        menuList: [],
        mainLabel: '',
        componentName: '',
        firstLogin: false,
        loginUser: '',
        token: '',
        checkYN: '',
        searchWord: '',
        signUpId: '',
        searchObj: '',
        menuId: '',
        active: '',
        popupShow: false
    },
    getters: {
        isLoggedIn(state) {
            return state.loginUser !== '';
        },
        getBoardId(state) {
            return state.boardId;
        },
        getFlag(state) {
            return state.flag;
        },
        getMenuList(state) {
            return state.menuList;
        },
        getComponentName(state) {
            return state.componentName;
        },
        getMainLable(state) {
            return state.mainLabel;
        },
        getLoginUser(state) {
            return state.loginUser;
        },
        getCheckYN(state) {
            return state.checkYN;
        },
        getPage(state) {
            return state.page;
        },
        getFirstLogin(state) {
            return state.firstLogin;
        },
        getSearchWord(state) {
            return state.searchWord;
        },
        getSignUpId(state) {
            return state.signUpId;
        },
        getSearchObj(state) {
            return state.searchObj;
        },
        getMenuId(state) {
            return state.menuId;
        },
        getActice(state) {
            return state.active;
        },
        getPopupShow(state) {
            return state.popupShow;
        }
    },
    mutations: {
        setToken(state, payload) {
            Vue.prototype.$session.set('token', payload);
            state.token = Vue.prototype.$session.get('token');
        },
        setBoardId(state, boardId) {
            state.boardId = boardId;
        },
        setFlag(state, flag) {
            state.flag = flag;
        },
        setMenuList(state, menuList) {
            state.menuList = menuList;
        },
        setComponentName(state, componentName) {
            state.componentName = componentName;
        },
        setMainLabel(state, mainLabel) {
            state.mainLabel = mainLabel;
        },
        setLoginUser(state, loginUser) {
            state.loginUser = loginUser;
        },
        clearLoginUser(state) {
            state.loginUser = '';
        },
        clearToken(state) {
            state.token = '';
        },
        setCheckYN(state, checkYN) {
            state.checkYN = checkYN;
        },
        setPage(state, page) {
            state.page = page;
        },
        setFirstLogin(state, firstLogin) {
            state.firstLogin = firstLogin;
        },
        setSearchWord(state, searchWord) {
            state.searchWord = searchWord;
        },
        setSignUpId(state, signUpId) {
            state.signUpId = signUpId;
        },
        setSearchObj(state, searchObj) {
            state.searchObj = searchObj;
        },
        setMenuId(state, menuId) {
            state.menuId = menuId;
        },
        setActive(state, active) {
            state.active = active;
        },
        setPopupShow(state, popupShow) {
            state.popupShow = popupShow;
        }
    }
});